import { render, staticRenderFns } from "./gradeChart.vue?vue&type=template&id=885def38&scoped=true&"
import script from "./gradeChart.vue?vue&type=script&lang=js&"
export * from "./gradeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885def38",
  null
  
)

export default component.exports